import React from 'react';

import Add from './Add';
import ListFamilyHistory from './List';

export default function Index() {
  return (
    <>
      <ListFamilyHistory />
      <Add />
    </>
  );
}
